import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

export { default as BasicSlider } from './BasicSlider';
export { SliderButton } from './SliderButton';
export { SliderControl } from './SliderControl';
